export default __webpack_public_path__ + "static/media/bonus-ico-active.d92770c6.svg";